module.exports = __webpack_public_path__ + "static/media/LAVA-HT.8707a2d7.svg";